module.exports = __webpack_public_path__ + "assets/img/Logitech-G-Landing-page-w960.1c9e9d94.jpg";